"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathWarning = exports.getStages = exports.getWorkflowForCase = exports.CaseGroupWorkflowsLevels = exports.getProcedureTask = exports.getNextTasks = exports.getNextTask = exports.getPastUpdate = exports.isPossibleTask = exports.isPossiblePath = exports.NextTaskType = exports.fulfilRequirements = exports.addTiming = exports.UpdateWorkflowSchema = exports.CreateWorkflowSchema = exports.PathType = exports.RequirementType = exports.TimingType = exports.TodoType = void 0;
const Joi = __importStar(require("joi"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const __1 = require("..");
const helpers_1 = __importDefault(require("../economy/helpers"));
const vouchers_1 = require("../economy/vouchers");
const interactions_1 = require("../interactions");
const updates_1 = require("../updates");
var TodoType;
(function (TodoType) {
    TodoType["AddVoucher"] = "ADD_VOUCHER";
    TodoType["AddBillingVoucher"] = "ADD_BILLING_VOUCHER";
    TodoType["RemoveVoucher"] = "REMOVE_VOUCHER";
    TodoType["CreateInteraction"] = "CREATE_INTERACTION";
    TodoType["CreateCreditorInteraction"] = "CREATE_CREDITOR_INTERACTION";
    TodoType["SetCollector"] = "SET_COLLECTOR";
    TodoType["SetCaseGroup"] = "SET_CASE_GROUP";
    TodoType["ConnectToDebtCollector"] = "CONNECT_TO_DEBT_COLLECTOR";
    TodoType["ReturnToConnectSource"] = "RETURN_TO_CONNECT_SOURCE";
    TodoType["MoveToTenant"] = "MOVE_TO_TENANT";
    TodoType["ChangeCaseStatus"] = "CHANGE_CASE_STATUS";
    TodoType["OutboundCall"] = "OUTBOUND_CALL";
    TodoType["SetCaseTag"] = "SET_ECONOMY_ACCOUNT_TAG";
    TodoType["DebtRegister"] = "DEBT_REGISTER";
    TodoType["DebtRegisterSkip"] = "DEBT_REGISTER_SKIP";
    TodoType["SubmitToCourt"] = "SUBMIT_TO_COURT";
    TodoType["ReadyToSubmitToCourt"] = "READY_TO_SUBMIT_TO_COURT";
    TodoType["SwitchWorkflow"] = "SWITCH_WORKFLOW";
    TodoType["SwitchBackToPreviousWorkflow"] = "SWITCH_BACK_TO_PREVIOUS_WORKFLOW";
    TodoType["MergeCase"] = "MERGE_CASE";
    TodoType["CreateProperties"] = "CREATE_PROPERTIES";
    TodoType["Bespoke"] = "BESPOKE";
})(TodoType || (exports.TodoType = TodoType = {}));
var TimingType;
(function (TimingType) {
    TimingType["Timespan"] = "TIMESPAN";
    TimingType["TimespanFromDueDate"] = "TIMESPAN_FROM_DUE_DATE";
})(TimingType || (exports.TimingType = TimingType = {}));
var RequirementType;
(function (RequirementType) {
    RequirementType["HasValidEmail"] = "HAS_VALID_EMAIL";
    RequirementType["HasNoValidEmail"] = "HAS_NO_VALID_EMAIL";
    RequirementType["HasValidAddress"] = "HAS_VALID_ADDRESS";
    RequirementType["HasNoValidAddress"] = "HAS_NO_VALID_ADDRESS";
    RequirementType["HasValidPhone"] = "HAS_VALID_PHONE";
    RequirementType["HasNoValidPhone"] = "HAS_NO_VALID_PHONE";
    RequirementType["HasValidCentralRegisterId"] = "HAS_VALID_CENTRAL_REGISTER_ID";
    RequirementType["HasNoValidCentralRegisterId"] = "HAS_NO_VALID_CENTRAL_REGISTER_ID";
    RequirementType["IsPrivate"] = "IS_PRIVATE";
    RequirementType["IsCompany"] = "IS_COMPANY";
    RequirementType["HasIncomingInteractions"] = "HAS_INCOMING_INTERACTIONS";
    RequirementType["HasEAN"] = "HAS_EAN";
    RequirementType["ReadyForEboks"] = "READY_FOR_EBOKS";
    RequirementType["HasUpdate"] = "HAS_UPDATE";
    RequirementType["DoesNotHaveUpdate"] = "DOES_NOT_HAVE_UPDATE";
    RequirementType["AmountThreshold"] = "AMOUNT_THRESHOLD";
    RequirementType["PercentageSplit"] = "PERCENTAGE_SPLIT";
    RequirementType["CaseGroup"] = "CASE_GROUP";
    RequirementType["HasFoundation"] = "HAS_FOUNDATION";
    RequirementType["DoesNotHaveFoundation"] = "DOES_NOT_HAVE_FOUNDATION";
    RequirementType["SpecificCreditor"] = "SPECIFIC_CREDITOR";
    RequirementType["CustomerHasTag"] = "CUSTOMER_HAS_TAG";
})(RequirementType || (exports.RequirementType = RequirementType = {}));
var PathType;
(function (PathType) {
    PathType["Normal"] = "NORMAL";
    PathType["ForMigration"] = "FOR_MIGRATION";
    PathType["DeprecatedTask"] = "DEPRECATED_TASK";
})(PathType || (exports.PathType = PathType = {}));
exports.CreateWorkflowSchema = Joi.object({
    title: Joi.string().required(),
    description: Joi.string().required(),
    tasks: Joi.any(),
    paths: Joi.any(),
});
exports.UpdateWorkflowSchema = Joi.object({
    title: Joi.string(),
    description: Joi.string(),
    tasks: Joi.any(),
    paths: Joi.any(),
});
const addTiming = (from, timing, caseVouchers) => {
    switch (timing.type) {
        case TimingType.Timespan: {
            const time = (0, moment_timezone_1.default)(from).add(timing.details.timespan[0], timing.details.timespan[1]);
            if (timing.details.time) {
                time
                    .tz('Europe/Copenhagen')
                    .set('hour', timing.details.time.hour)
                    .set('minute', timing.details.time.minute)
                    .startOf('minute');
            }
            return time.tz('UTC').format();
        }
        case TimingType.TimespanFromDueDate: {
            if (!caseVouchers) {
                throw new Error('No case vouchers provided');
            }
            const vouchersSorted = caseVouchers
                .filter((caseVoucher) => caseVoucher.category === vouchers_1.VoucherCategory.PRINCIPAL &&
                caseVoucher.dueDate)
                .sort((a, b) => new Date(b.dueDate || b.date).getTime() -
                new Date(a.dueDate || a.date).getTime());
            const latestDueDate = (vouchersSorted[0] && vouchersSorted[0].dueDate) || undefined;
            const timeFromDueDate = (0, moment_timezone_1.default)(latestDueDate || from).add(timing.details.timespan[0], timing.details.timespan[1]);
            if (timing.details.time) {
                timeFromDueDate
                    .tz('Europe/Copenhagen')
                    .set('hour', timing.details.time.hour)
                    .set('minute', timing.details.time.minute)
                    .startOf('minute');
            }
            return timeFromDueDate.tz('UTC').format();
        }
        default:
            throw new Error('TimingType not handled');
    }
};
exports.addTiming = addTiming;
const uuidToFraction = (uuid) => {
    return parseInt(uuid.slice(0, 8), 16) / 16 ** 8;
};
const resonsForNotDeliverable = [
    'mailbox_does_not_exist',
    'No MX records found for domain',
    'failed custom grammar check for',
];
const fulfilRequirements = (requirements, context) => {
    const centralRegisterIdIsValid = context.contact
        ? context.isCompany
            ? (0, __1.validateCVR)(context.contact.cvr)
            : (0, __1.validateCPR)(context.contact.cpr)
        : null;
    return requirements.every((requirement) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        switch (requirement.type) {
            case RequirementType.HasValidEmail: {
                const emailSyntaxIsValid = (0, __1.validateEmail)(((_a = context.contact) === null || _a === void 0 ? void 0 : _a.email) || '');
                const emailValidation = context.contact &&
                    context.contact.emailValidations &&
                    context.contact.emailValidations.find((emailValidation) => { var _a; return emailValidation.address === ((_a = context.contact) === null || _a === void 0 ? void 0 : _a.email); });
                const emailExist = !(emailValidation && emailValidation.reason
                    ? emailValidation.reason.some((reason) => resonsForNotDeliverable.some((_reason) => reason.indexOf(_reason) > -1))
                    : false);
                return emailSyntaxIsValid && emailExist;
            }
            case RequirementType.HasNoValidEmail: {
                const noEmailSyntaxIsValid = (0, __1.validateEmail)(((_b = context.contact) === null || _b === void 0 ? void 0 : _b.email) || '');
                const noEmailValidation = context.contact &&
                    context.contact.emailValidations &&
                    context.contact.emailValidations.find((emailValidation) => { var _a; return emailValidation.address === ((_a = context.contact) === null || _a === void 0 ? void 0 : _a.email); });
                const noEmailExist = !(noEmailValidation &&
                    noEmailValidation.reason
                    ? noEmailValidation.reason.some((reason) => resonsForNotDeliverable.some((_reason) => reason.indexOf(_reason) > -1))
                    : false);
                return !(noEmailSyntaxIsValid && noEmailExist);
            }
            case RequirementType.HasValidPhone: {
                const phoneSyntaxValid = (0, __1.validatePhone)((_c = context.contact) === null || _c === void 0 ? void 0 : _c.phone);
                const phoneValidation = (_e = (_d = context.contact) === null || _d === void 0 ? void 0 : _d.phoneValidations) === null || _e === void 0 ? void 0 : _e.find((phoneValidation) => { var _a; return phoneValidation.phone === ((_a = context.contact) === null || _a === void 0 ? void 0 : _a.phone); });
                const phoneExist = !(phoneValidation && phoneValidation.validNumber == 'not_valid');
                return phoneSyntaxValid && phoneExist;
            }
            case RequirementType.HasNoValidPhone: {
                const phoneSyntaxValid = (0, __1.validatePhone)((_f = context.contact) === null || _f === void 0 ? void 0 : _f.phone);
                const phoneValidation = (_h = (_g = context.contact) === null || _g === void 0 ? void 0 : _g.phoneValidations) === null || _h === void 0 ? void 0 : _h.find((phoneValidation) => { var _a; return phoneValidation.phone === ((_a = context.contact) === null || _a === void 0 ? void 0 : _a.phone); });
                const phoneExist = !(phoneValidation && phoneValidation.validNumber == 'not_valid');
                return !(phoneSyntaxValid && phoneExist);
            }
            case RequirementType.HasValidAddress:
                return (0, __1.validateAddress)((_j = context.contact) === null || _j === void 0 ? void 0 : _j.address);
            case RequirementType.HasNoValidAddress:
                return !(0, __1.validateAddress)((_k = context.contact) === null || _k === void 0 ? void 0 : _k.address);
            case RequirementType.HasValidCentralRegisterId:
                return centralRegisterIdIsValid !== null && centralRegisterIdIsValid !== void 0 ? centralRegisterIdIsValid : false;
            case RequirementType.HasNoValidCentralRegisterId:
                return !centralRegisterIdIsValid;
            case RequirementType.IsCompany:
                return context.isCompany;
            case RequirementType.IsPrivate:
                return !context.isCompany;
            case RequirementType.HasEAN:
                return !!((_l = context.contact) === null || _l === void 0 ? void 0 : _l.ean);
            case RequirementType.ReadyForEboks: {
                const deliverability = ((_p = (_o = (_m = context.contact) === null || _m === void 0 ? void 0 : _m.deliverability) === null || _o === void 0 ? void 0 : _o.eboks) !== null && _p !== void 0 ? _p : [])
                    .map((x) => x)
                    .reverse();
                if (context.contact == null) {
                    return false;
                }
                const centralRegisterId = context.contact.isCompany
                    ? context.contact.cvr
                    : context.contact.cpr;
                if (centralRegisterId &&
                    (context.contact.isCompany
                        ? (0, __1.validateCVR)(context.contact.cvr)
                        : (0, __1.validateCPR)(context.contact.cpr))) {
                    const attempt = deliverability.find((attempt) => attempt.recipient.type === interactions_1.EBoksRecipientType.CentralRegisterId);
                    if (attempt == null || attempt.success) {
                        return true;
                    }
                }
                const address = context.contact.address;
                if (context.contact.isCompany) {
                    return false;
                }
                if (!context.contact.name) {
                    return false;
                }
                if (address == null) {
                    return false;
                }
                const names = context.contact.name.split(' ');
                const firstName = names.slice(0, -1).join(' ');
                const lastName = names[names.length - 1];
                const attempt = deliverability.find((attempt) => {
                    return (attempt.recipient.type === interactions_1.EBoksRecipientType.KVHX &&
                        attempt.recipient.firstName === firstName &&
                        attempt.recipient.lastName === lastName &&
                        (address.KVHX != null
                            ? attempt.recipient.kvhx === address.KVHX
                            : true));
                });
                if (attempt == null || attempt.success) {
                    return true;
                }
                return false;
            }
            case RequirementType.HasUpdate:
                return !!context.updates.find((update) => update.updateTypeId === requirement.details.updateTypeId);
            case RequirementType.DoesNotHaveUpdate:
                return !context.updates.find((update) => update.updateTypeId === requirement.details.updateTypeId);
            case RequirementType.CaseGroup:
                return context.caseGroupId === requirement.details.caseGroupId;
            case RequirementType.PercentageSplit: {
                const fraction = uuidToFraction(context.caseId);
                const from = requirement.details.from;
                const to = requirement.details.to;
                return fraction >= from && fraction <= to;
            }
            case RequirementType.AmountThreshold: {
                const balance = ((_q = requirement.details.onlySelectedCategories) === null || _q === void 0 ? void 0 : _q.length)
                    ? -requirement.details.onlySelectedCategories.reduce((acc, category) => acc +
                        helpers_1.default.overview.balanceCategory(context.caseVouchers, category), 0)
                    : -helpers_1.default.overview.balance(context.caseVouchers);
                if (requirement.details.moreThan) {
                    return balance >= requirement.details.amount;
                }
                else {
                    return balance <= requirement.details.amount;
                }
            }
            case RequirementType.HasFoundation: {
                if (requirement.details.onlySelectedFoundationTypes &&
                    ((_r = context.foundationTypes) === null || _r === void 0 ? void 0 : _r.length) > 0) {
                    return (context.hasFoundation &&
                        requirement.details.foundationTypes.some((type) => context.foundationTypes.includes(type)));
                }
                else {
                    return context.hasFoundation;
                }
            }
            case RequirementType.DoesNotHaveFoundation:
                return !context.hasFoundation;
            case RequirementType.SpecificCreditor:
                return context.creditorId === requirement.details.creditorId;
            case RequirementType.CustomerHasTag:
                return (context.customerTags || [])
                    .map((tag) => tag.tag)
                    .includes(requirement.details.tag);
            case RequirementType.HasIncomingInteractions:
                return (context.interactions.filter((i) => i.direction === interactions_1.Direction.INCOMING &&
                    ![interactions_1.InteractionType.ClientNote, interactions_1.InteractionType.Note].includes(i.type)).length > 0);
        }
    });
};
exports.fulfilRequirements = fulfilRequirements;
var NextTaskType;
(function (NextTaskType) {
    NextTaskType["NoNextTask"] = "NO_NEXT_TASK";
    NextTaskType["ManualTask"] = "MANUAL_TASK";
    NextTaskType["NormalTask"] = "NORMAL_TASK";
    NextTaskType["StartingPointTask"] = "STARTING_POINT_TASK";
})(NextTaskType || (exports.NextTaskType = NextTaskType = {}));
const isPossiblePath = (path, context, onlyPathTypes) => (!onlyPathTypes || onlyPathTypes.includes(path.type)) &&
    (0, exports.fulfilRequirements)(path.requirements, context);
exports.isPossiblePath = isPossiblePath;
const isPossibleTask = (task, context, paths, onlyPathTypes) => {
    if (task.startingPoint) {
        return (0, exports.fulfilRequirements)(task.startingPointRequirements || [], context);
    }
    else {
        const availablePaths = (paths || []).filter((path) => (0, exports.isPossiblePath)(path, context, onlyPathTypes));
        return availablePaths.length > 0;
    }
};
exports.isPossibleTask = isPossibleTask;
const getPastUpdate = (updates, workflowId) => updates
    .filter((update) => update.taskId &&
    update.state !== updates_1.UpdateState.RolledBack &&
    (!update.byWorkflowId || update.byWorkflowId === workflowId))
    .sort((a, b) => (0, moment_timezone_1.default)(b.pausedAt).toDate().getTime() -
    (0, moment_timezone_1.default)(a.pausedAt).toDate().getTime())[0];
exports.getPastUpdate = getPastUpdate;
const getNextTask = (updates, workflow, context) => {
    const pastUpdate = (0, exports.getPastUpdate)(context.updates, workflow.workflowId);
    if (!pastUpdate) {
        const startingPointTasks = workflow.tasks
            .filter((task) => task.startingPoint && (0, exports.isPossibleTask)(task, context, workflow.paths))
            .sort((a, b) => (a.startingPoint ? a.startingPointPriority || 0 : 0) -
            (b.startingPoint ? b.startingPointPriority || 0 : 0));
        const startingPointTask = startingPointTasks[0];
        if (!startingPointTask) {
            return { type: NextTaskType.NoNextTask, noNextStep: true, pastUpdate };
        }
        return {
            type: NextTaskType.StartingPointTask,
            pastUpdate,
            task: startingPointTask,
            path: null,
            date: (0, moment_timezone_1.default)()
                .tz('Europe/Copenhagen')
                .set('hour', 7)
                .startOf('hour')
                .format(),
            tasks: startingPointTasks,
            manual: (startingPointTask.startingPoint &&
                startingPointTask.startingPointManual) ||
                undefined,
        };
    }
    else {
        const nextPossiblePaths = (0, exports.getNextTasks)(workflow, pastUpdate.taskId);
        const nextPossibleTaskPaths = nextPossiblePaths
            .filter(({ path }) => (0, exports.isPossiblePath)(path, context))
            .map(({ path, task }) => {
            return { task, path, pastUpdate };
        })
            .sort((a, b) => a.path.priority - b.path.priority);
        const nextPossibleTaskPath = nextPossibleTaskPaths[0];
        if (!nextPossibleTaskPath) {
            return {
                type: NextTaskType.NoNextTask,
                noNextStep: true,
                pastUpdate,
            };
        }
        const { task, path } = nextPossibleTaskPath;
        if (path.manual) {
            return {
                type: NextTaskType.ManualTask,
                task,
                path,
                manual: true,
                tasks: nextPossibleTaskPaths.map(({ task }) => task),
                pastUpdate,
            };
        }
        else {
            return {
                type: NextTaskType.NormalTask,
                task,
                path,
                date: (0, exports.addTiming)(pastUpdate.pausedAt, path.timing, context.caseVouchers),
                pastUpdate,
            };
        }
    }
};
exports.getNextTask = getNextTask;
const getNextTasks = (workflow, fromTaskId) => {
    if (!fromTaskId) {
        return [];
    }
    const paths = workflow.paths.filter((path) => path.source === fromTaskId);
    return paths.map((path) => {
        const task = workflow.tasks.find((task) => task.id === path.target);
        if (!task) {
            throw new Error('Workflow corrupt. Could not find taskId: ' + path.target);
        }
        return {
            path,
            task,
        };
    });
};
exports.getNextTasks = getNextTasks;
const getProcedureTask = (updates, tasks, context) => {
    const startingPointTasks = tasks
        .filter((task) => (0, exports.isPossibleTask)(task, context, []))
        .sort((a, b) => (a.startingPoint ? a.startingPointPriority || 0 : 0) -
        (b.startingPoint ? b.startingPointPriority || 0 : 0));
    const startingPointTask = startingPointTasks[0];
    if (!startingPointTask) {
        return null;
    }
    return {
        task: startingPointTask,
        manual: (startingPointTask.startingPoint &&
            startingPointTask.startingPointManual) ||
            undefined,
    };
};
exports.getProcedureTask = getProcedureTask;
var CaseGroupWorkflowsLevels;
(function (CaseGroupWorkflowsLevels) {
    CaseGroupWorkflowsLevels["Tenant"] = "tenant";
    CaseGroupWorkflowsLevels["Creditor"] = "creditor";
})(CaseGroupWorkflowsLevels || (exports.CaseGroupWorkflowsLevels = CaseGroupWorkflowsLevels = {}));
const getWorkflowForCase = (creditor, tenant, caseGroupId) => {
    var _a, _b;
    let setOnTenant = !!(!creditor.defaultWorkflowId && tenant.defaultWorkflowId);
    let setOnCreditor = !!creditor.defaultWorkflowId;
    let caseGroupWorkflow;
    if (creditor.caseGroupWorkflows.length > 0 && caseGroupId) {
        caseGroupWorkflow = (_a = creditor.caseGroupWorkflows.find((cg) => cg.caseGroupId === caseGroupId)) === null || _a === void 0 ? void 0 : _a.workflowId;
        if (caseGroupWorkflow) {
            setOnTenant = false;
            setOnCreditor = true;
        }
    }
    if (tenant.caseGroupWorkflows.length > 0 &&
        !caseGroupWorkflow &&
        caseGroupId) {
        caseGroupWorkflow = (_b = tenant.caseGroupWorkflows.find((cg) => cg.caseGroupId === caseGroupId)) === null || _b === void 0 ? void 0 : _b.workflowId;
        if (caseGroupWorkflow) {
            setOnTenant = true;
            setOnCreditor = false;
        }
    }
    return {
        workflowId: caseGroupWorkflow
            ? caseGroupWorkflow
            : creditor.defaultWorkflowId || tenant.defaultWorkflowId,
        setOnTenant,
        setOnCreditor,
    };
};
exports.getWorkflowForCase = getWorkflowForCase;
const getStages = (tasks, updateTypes) => {
    const stagesMap = tasks.reduce((acc, task) => {
        const updateType = updateTypes.find((ut) => ut.updateTypeId === task.updateTypeId);
        const groupId = updateType === null || updateType === void 0 ? void 0 : updateType.groupId;
        if (!groupId)
            return acc;
        if (!acc[groupId]) {
            acc[groupId] = {
                groupId,
                positions: [],
                taskIdMap: {},
            };
        }
        acc[groupId] = {
            groupId,
            positions: acc[groupId].positions.concat(task.position),
            taskIdMap: Object.assign(Object.assign({}, acc[groupId].taskIdMap), { [task.id]: true }),
        };
        return acc;
    }, {});
    const stagesOrdered = Object.values(stagesMap)
        .map((stage) => {
        return Object.assign(Object.assign({}, stage), { minDistance: stage.positions.reduce((acc, pos) => {
                const _distance = distance(pos);
                if (_distance < acc) {
                    return _distance;
                }
                else {
                    return acc;
                }
            }, 0) });
    })
        .sort((a, b) => a.minDistance - b.minDistance);
    return stagesOrdered.map((s) => ({
        groupId: s.groupId,
        taskIdMap: s.taskIdMap,
    }));
};
exports.getStages = getStages;
const distance = (position) => {
    const a = 500 - position.x;
    const b = 120 - position.y;
    return Math.sqrt(a * a + b * b);
};
var PathWarning;
(function (PathWarning) {
    PathWarning["ValidEmailRequirementRecommended"] = "VALID_EMAIL_REQUIREMENT_RECOMMENDED";
    PathWarning["ValidAddressRequirementRecommended"] = "VALID_ADDRESS_REQUIREMENT_RECOMMENDED";
    PathWarning["ReadyForEboksRequirementRecommended"] = "READY_FOR_EBOKS_REQUIREMENT_RECOMMENDED";
})(PathWarning || (exports.PathWarning = PathWarning = {}));
//# sourceMappingURL=index.js.map